let setLoaderState;

export const registerLoader = (stateSetter) => {
  setLoaderState = stateSetter;
};

export const showLoader = () => {
  if (setLoaderState) setLoaderState(true);
};

export const hideLoader = () => {
  if (setLoaderState) setLoaderState(false);
};